/**
 * 设置布局
 */

import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { headersType, layoutStore } from '@/stores/layout';
import globalStore from '@/stores/store';

const useLayout = ({
  hideNavBar,
  hideHeader,
  headers = {},
  style = {}
}: {
  hideNavBar?: boolean;
  headers?: headersType;
  style?: React.CSSProperties;
  hideHeader?: Boolean;
}) => {
  const { pathname } = useLocation();
  const { isLogin } = globalStore.initialState;

  useLayoutEffect(() => {
    layoutStore.setHeader(headers);
    layoutStore.setNavbar(!!hideNavBar);
    layoutStore.setHideHeader(!!hideHeader);
    layoutStore.setStyle(style);
  }, [pathname, isLogin]);
};

export default useLayout;
